module.exports = function () {
  return new Worker(__webpack_public_path__ + "5c0274259313795762a2.worker.js");
};